import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção da ficha cadastral médico). */
export type EtiquetaEnderecoMedicoJob = ReportJob;
export type EtiquetaEnderecoMedicoJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Etiqueta de Endereço do Médico. */
@Injectable({ providedIn: 'root' })
export class EtiquetaEnderecoMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'etiqueta-endereco-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.etiquetaEnderecoMedico;
}
